module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "login-container boxed-login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4"
  }, [_c('div', {
    staticClass: "login-form-container"
  }, [_c('div', {
    staticClass: "j-forms",
    attrs: {
      "id": "forms-login",
      "novalidate": "novalidate"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-form-content"
  }, [_c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "姓名*",
      "name": "user_name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('user_name')),
      expression: "errors.has('user_name')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('user_name')),
      expression: "errors.has('user_name')"
    }],
    staticClass: "help text-danger"
  }, [_vm._v("這是必填項目喔\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "id": "login",
      "name": "email",
      "placeholder": "Email*"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help text-danger"
  }, [_vm._v("這是必填項目喔")])])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "password",
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "密碼*"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help text-danger"
  }, [_vm._v("這是必填項目喔")])])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "password",
      "name": "repassword",
      "id": "repassword",
      "placeholder": "確認密碼*",
      "data-vv-as": "password"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('repassword')),
      expression: "errors.has('repassword')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('repassword')),
      expression: "errors.has('repassword')"
    }],
    staticClass: "help text-danger"
  }, [_vm._v("兩次密碼不同")])])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_c('label', {
    staticClass: "checkbox",
    attrs: {
      "for": "agreement"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "name": "agreement",
      "id": "agreement",
      "placeholder": "確認密碼*"
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('small', [_vm._v("我已閱讀並同意 "), _c('b', {
    staticClass: "text-info pointer",
    on: {
      "click": function($event) {
        _vm.webTermModal = true
      }
    }
  }, [_vm._v("網站使用條款")]), _vm._v(" 與 "), _c('b', {
    staticClass: "text-info pointer",
    on: {
      "click": function($event) {
        _vm.privacyTermModal = true
      }
    }
  }, [_vm._v("隱私權政策")])])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('agreement')),
      expression: "errors.has('agreement')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('agreement')),
      expression: "errors.has('agreement')"
    }],
    staticClass: "help text-danger"
  }, [_vm._v("這是必填項目喔")])])])]), _vm._v(" "), _c('div', {
    staticClass: "login-form-footer",
    staticStyle: {
      "padding-top": "0px",
      "margin-bottom": "2px"
    }
  }, [(_vm.loading) ? _c('button', {
    staticClass: "btn-block btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                建立帳號中...\n              ")]) : _c('button', {
    staticClass: "btn-block btn btn-success",
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("送出註冊")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n              已有帳號？點此登入\n            ")])], 1)])])]), _vm._v(" "), _c('footer', {
    staticClass: "login-page-footer"
  })]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), (_vm.webTermModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.webTermModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.webTermModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body scroll"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('webUseTerm')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.webTermModal = false
      }
    }
  }, [_vm._v("\n                關閉\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.privacyTermModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.privacyTermModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.privacyTermModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body scroll"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('PrivacyTerm')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.privacyTermModal = false
      }
    }
  }, [_vm._v("\n                關閉\n              ")])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form-header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-pic",
    attrs: {
      "src": require("../../assets/img/logo3.png"),
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "login"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-account"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "login"
    }
  }, [_c('i', {
    staticClass: "far fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "password"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "password"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Flowneat網站使用條款")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Flowneat隱私權政策")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-045877eb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Signup.vue
// module id = 663
// module chunks = 4